<template>
  <div>
    <div class="ai-chat-top item-display" ref="listBox">
      <i class="el-icon-close close-icon" @click="closeAi"></i>
      <template v-for="(item, index) in chatConentList">
        <chatElementRebot
          v-if="item.msgType === 'AI'"
          :messageItem="item"
          :content="item.msg"
          :loading="item.loading"
          :index="index"
        ></chatElementRebot>
        <chatElementText
          v-else
          :messageItem="item"
          :content="item.msg"
          :loading="item.loading"
        ></chatElementText>
      </template>
    </div>
    <!-- <chatAudioToText ref="chatAudioToText" @audioEndConfirm="audioEndConfirm" style="margin-right: 10px"> </chatAudioToText> -->
    <chatAudioRealtime
      ref="chatAudioRealtime"
      class="chat-audio-realtime"
      @message="message"
      @update:message="updateMessage"
      @closed="realtimeClosed"
    ></chatAudioRealtime>
    <listen ref="listen" @wakeUp="wakeUp"></listen>
    <speaker ref="speaker"></speaker>
  </div>
</template>

<script>
import chatElementText from "./chat-element/chat-element-text.vue";
import chatElementRebot from "./chat-element/chat-element-rebot.vue";
import chatAudioToText from "./components/chat-audio-to-text-xunfei.vue";
import chatAudioRealtime from "./components/chat-audio-realtime-xunfei.vue";
import listen from "@/components/speech-recognition-assistant/listen-whisper.vue";
import speaker from "@/components/speech-recognition-assistant/speak-xunfei.vue";

import axios from "axios";
export default {
  components: {
    chatElementText,
    chatElementRebot,
    // chatAudioToText,
    chatAudioRealtime,
    listen,
    speaker,
  },
  data() {
    return {
      timer: null,
      chatConentList: [],
      value: "",
    };
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      this.scrollTobottom();
    });
    this.addClickListener();
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
    this.removeClickListener();
  },
  computed: {
    isWakeUp() {
      return this.$store.state.aiChat.isWakeUp;
    },
  },
  watch: {
    "$store.state.aiChat.chatList": {
      handler(val) {
        this.chatConentList = val;
        this.scrollTobottom();
      },
      deep: true,
      immediate: true,
    },
    isWakeUp() {
      this.toggleShow();
    },
  },
  methods: {
    audioEndConfirm(params) {
      console.log("audioEndConfirm", params);
    },

    /**
     * //  添加到聊天
     * @param {*} item   要添加的内容，
     * @param {*} brotherMsgId   要添加的id
     */
    addToChat(params) {
      this.$store.commit("setChatList", {
        msgType: "question",
        infoType: "text",
        msg: params.askInfo,
        ...params,
      });
    },
    /**
     * //  添加临时结果到聊天
     */
    genTempReplyToChat() {
      let loadingObj = { msgType: "AI", loading: true };
      this.$store.commit("setChatList", loadingObj);
    },
    /**
     * //  添加临时结果到聊天
     */
    setRealReplyToChat(rempReplyItem, realItem) {
      Object.assign(rempReplyItem, realItem);
      rempReplyItem.loading = false;
    },

    /**
     * 获取审批列表
     * */
    async getList() {
      this.chatConentList = this.$store.state.aiChat.chatList;
      console.log("getList----chatConentList", this.chatConentList);
    },
    doDelete(id) {
      // console.log("删除", id);

      return (() => {
        this.$request.elnAppChatMessageDelete(id).then((result) => {
          let index = this.chatConentList.findIndex((t) => t.id === id);
          if (index >= 0) {
            this.chatConentList.splice(index, 1);
          }
        });
      })();
    },

    scrollTobottom() {
      if (this.$refs.listBox) {
        console.log(
          "this.$refs.listBox",
          this.$refs.listBox,
          this.$refs.listBox.scrollHeight
        );
        this.$refs.listBox.scrollTop = this.$refs.listBox.scrollHeight;
        this.$nextTick(() => {
          this.$refs.listBox.scrollTop = this.$refs.listBox.scrollHeight;
        });
      }
    },
    speak(text) {
      this.$refs.speaker.stop();
      if (this.$refs.speaker && text) {
        return this.$refs.speaker.speak(text);
      }
    },

    stopSpeak() {
      if (this.$refs.speaker) {
        return this.$refs.speaker.stop();
      }
    },
    message(params) {
      this.addToChat(params);
    },

    updateMessage(item) {
      let index = this.chatConentList.findIndex((t) => t.id === item.id);
      if (index >= 0) {
        this.chatConentList.splice(index, 1, item);
        // console.log("111111111111111111111", item)
      }
    },

    start() {
      this.$store.commit("setIsWakeUp", true);
      this.$store.commit("setWakeUpChatList");
      this.speak("我在");
      this.$refs.chatAudioRealtime.start(false);
      this.$nextTick(() => {
        this.scrollTobottom();
      });
    },
    wakeUp() {
      this.$refs.chatAudioRealtime.start(true);
      // this.$refs.listen.stop();
      this.$nextTick(() => {
        this.scrollTobottom();
      });
    },
    realtimeClosed() {
      this.$refs.listen.init();
    },
    addClickListener() {
      document.addEventListener("click", this.handleClickOutsideIframe);
    },
    removeClickListener() {
      document.removeEventListener("click", this.handleClickOutsideIframe);
    },
    handleClickOutsideIframe(event) {
      if (window.parent) {
        window.parent.postMessage("click", "*");
      }
    },
    closeAi() {
      // this.$refs.chatAudioRealtime.doClose();
      this.$store.commit("setIsWakeUp", false);
    },
    toggleShow() {
      if (
        document
          .querySelector(".ai-chat-top")
          .classList.contains("item-display")
      ) {
        document.querySelector(".ai-chat-top").classList.remove("item-display");
        // 这里是关键:display和opacity同时执行，动画无法正常执行，必须设置1个时间间隔,只要大于0就行
        setTimeout(function () {
          document
            .querySelector(".ai-chat-top")
            .classList.remove("item-opacity");
        }, 1);
      } else {
        document.querySelector(".ai-chat-top").classList.add("item-opacity");
        setTimeout(function () {
          document.querySelector(".ai-chat-top").classList.add("item-display");
        }, 500);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ai-chat-top {
  opacity: 1;
  transition: opacity 0.5s linear;
  width: 40%;
  height: 20%;
  flex-shrink: 0;
  padding: 12px 12px 0;
  border: 3px solid;
  background: #0c1f3fe6;
  border-image-source: linear-gradient(to right, #3f71e7, #4fd0ff);
  border-image-slice: 1;
  clip-path: inset(0 round 10px);
  position: absolute;
  z-index: 100;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20%;
  overflow: auto;
  border-radius: 12px;
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
  &::-webkit-scrollbar-corner {
    background: transparent;
  }
  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    cursor: pointer;
  }
}
.item-display {
  display: none;
}
.item-opacity {
  opacity: 0;
}
</style>
